import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import classNames from 'classnames';

import MinusIcon from '../../../../components/icons/MinusIcon';
import PlusIcon from '../../../../components/icons/PlusIcon';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  minDisabled: PropTypes.bool,
  maxDisabled: PropTypes.bool,
  removeButtons: PropTypes.bool,
};

const CheckoutItemQuantityInput = ({
  onChange,
  value,
  min = 1,
  max = 999,
  className,
  label = 'item',
  disabled,
  minDisabled,
  maxDisabled,
  removeButtons,
}) => {
  const classes = classNames({
    'checkout-item-quantity-input': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {!removeButtons && (
        <button
          disabled={value === min || disabled || minDisabled}
          className="checkout-item-quantity-input-btn checkout-item-quantity-input-btn-minus"
          onClick={() => onChange(Math.max(min, value - 1))}
          title="Decrease quantity"
        >
          <MinusIcon color="#fff" />
        </button>
      )}

      <span className="checkout-item-quantity-input-value" title="Item value">
        {value} {pluralize(label, value)}
      </span>

      {!removeButtons && (
        <button
          disabled={value === max || disabled || maxDisabled}
          className="checkout-item-quantity-input-btn checkout-item-quantity-input-btn-plus"
          onClick={() => onChange(Math.min(max, value + 1))}
          title="Increase quantity"
        >
          <PlusIcon color="#fff" />
        </button>
      )}
    </div>
  );
};

CheckoutItemQuantityInput.propTypes = propTypes;

export default CheckoutItemQuantityInput;
